// utils/tokenStorage.js
const TOKEN_KEY = process.env.NEXT_PUBLIC_API_KEY || "auth-token";
const REFRESH_TOKEN_KEY =
  process.env.NEXT_PUBLIC_REFRESH_TOKEN_KEY || "default-refresh-token-key";

const getRefreshToken = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }
  return null;
};

// Retrieve the authentication token from local storage
const getToken = async () => {
  // Check if running on the client side
  if (typeof window !== "undefined") {
    const token = localStorage.getItem(TOKEN_KEY);
    // Validate token expiry
    // if (token) {
    //   const parsedToken = JSON.parse(atob(token.split('.')[1]));
    //   const tokenExp = parsedToken.exp * 1000; // Convert to milliseconds

    //   if (tokenExp < Date.now()) {
    //     // Token has expired
    //     console.warn('Token has expired');
    //     clearToken();
    //     return null;
    //   }
    // }

    return token;
  }

  // Return null if running on the server side
  return null;
};

// Set the authentication token in local storage
const setToken = (token) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

// Clear the authentication token from local storage
const clearToken = () => {
  // Check if running on the client side
  if (typeof window !== "undefined") {
    localStorage.removeItem(TOKEN_KEY);
  }
};

const getRoleOfLoggedInUser = (roleId) => {
  const roles = {
    "6613bb85e851d2173d3ae9f5": "admin",
    "6613bdccbbae6a9f72f61a5f": "teacher",
    "6613bdfdbbae6a9f72f61a62": "student",
    "66464b0ef164be78053d795b": "admin",
    "66464b1bf164be78053d795e": "teacher",
    "66464b23f164be78053d7961": "student",
  };
  const liveRoles = {
    "6643649a01098e2e2d5afbfe": "admin",
    "664364ba01098e2e2d5afc01": "teacher",
    "664364ce01098e2e2d5afc04": "student",
  };
  return roles[roleId] ? roles[roleId] : liveRoles[roleId];
};

const getStudentRoleData = () => {
  return { roleId: "6613bdfdbbae6a9f72f61a62", roleName: "student" };
};

export {
  getToken,
  setToken,
  clearToken,
  getRefreshToken,
  getRoleOfLoggedInUser,
  getStudentRoleData,
};
